<list
  [listItems]="customListDirectories$ | async"
  [isParent]="true"
  [maxTitleLength]="100"
  (selectDirectory)="selectDirectory.emit($event)"
  (removeItem)="removeItem($event)"
  (save)="onSave($event)"
></list>
